import React from 'react';
import RootSvg, { RootSvgProps } from '@/components/icons/RootSvg';

export default function SvgHelp(props: RootSvgProps) {
  return (
    <RootSvg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7 0.599609C8.76746 0.599609 10.3666 1.31578 11.5254 2.47461C12.6842 3.63346 13.4004 5.23255 13.4004 7C13.4004 8.76746 12.6842 10.3666 11.5254 11.5254C10.3666 12.6842 8.76746 13.4004 7 13.4004C5.23255 13.4004 3.63346 12.6842 2.47461 11.5254C1.31578 10.3666 0.599609 8.76746 0.599609 7C0.599609 5.23254 1.31578 3.63346 2.47461 2.47461C3.63346 1.31578 5.23254 0.599609 7 0.599609Z"
        stroke="#6E6E6E"
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
      <path
        d="M7.02632 8.38014V7.18012C8.02043 7.18012 8.82632 6.37422 8.82632 5.3801C8.82632 4.38598 8.02043 3.58008 7.02632 3.58008C6.03221 3.58008 5.22632 4.38598 5.22632 5.3801"
        stroke="#6E6E6E"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.02748 10.9734C7.35885 10.9734 7.62748 10.7048 7.62748 10.3734C7.62748 10.0421 7.35885 9.77344 7.02748 9.77344C6.69612 9.77344 6.42749 10.0421 6.42749 10.3734C6.42749 10.7048 6.69612 10.9734 7.02748 10.9734Z"
        fill="#6E6E6E"
      />
    </RootSvg>
  );
}
